import { Info } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { DownArrow, LogView, Reload, UpArrow } from '../../assets/images/svg/icon'
import constants from '../../constants/constants'
import { ErrorToast } from '../../shared'
import AcceptedInvoice from './acceptedInvoice'
import PendingToAcceptInvoice from './pendingToAcceptInvoice'
import RejectedInvoice from './rejectedInvoice'
import CustomValuesHook from '../../functions/myHooks/CustomValuesHook'
import ReservedInvoice from './reserveInvoice'

const InvoiceTable = ({ columns = [],
  data,
  setData,
  selectedStatus,
  loading = false,
  setRowReservedInPending,
  setRowRejectedInPending,
  setIsReservedAddedtoeAcceptInvoice,
  isReservedAddedtoeAcceptInvoice,
  setContent,
  setTitle,
  setShow,
  lastFactorNumber,
  setIdOfNewRow,
  idOfNewRow,
  setIsDeleted,
  setIsReserved,
  isDeleted,
  isReserved,
  setItemForDownload,
  newReserved,
  setSelectedForCheckAgain,
  setRowBckReservedInPending,
  setviewDetail,
  checkedList,
  setCheckedList,
  setItemInLoading,
  itemInLoading,
  setIsApprove,
  setResendItemInLoading,
  resendItemInLoading,
  statusMovadianSelected,
  setOriginData,
  originDataToPaging,
  reservedInPendInvoice,


}) => {
  const [states, setStates] = CustomValuesHook({ pageNumber: 1, pageSize: 10, pages: [], displayPageCount: 5 })



  const UpArrowFn = (item, e) => {
    e.preventDefault();
    let idTablePrev = item.idTable
    let prevItem = item.InvoiceNumberInFactor

    if (idTablePrev !== 0) {
      let tempArr = { ...data }
      let tempCurrent = tempArr.data.splice(idTablePrev, 1)//delete current row
      let tempPrev = tempArr.data.splice(idTablePrev - 1, 1)//delete prev row   

      //swapp row content
      let tempRow;
      tempRow = tempCurrent[0].row;
      tempCurrent[0].row = tempPrev[0].row;
      tempPrev[0].row = tempRow;

      //swapp InvoiceNumberInFactorFa
      if (tempPrev[0]?.OfficialFactorType !== 2) {
        let tempInvoiceNumberInFactorFa;
        tempInvoiceNumberInFactorFa = tempCurrent[0].InvoiceNumberInFactorFa;
        tempCurrent[0].InvoiceNumberInFactorFa = tempPrev[0].InvoiceNumberInFactorFa;
        tempPrev[0].InvoiceNumberInFactorFa = tempInvoiceNumberInFactorFa;
      }

      //swapp InvoiceNumberInFactor
      if (tempPrev[0]?.OfficialFactorType !== 2) {
        let tempInvoiceNumberInFactor;
        tempInvoiceNumberInFactor = tempCurrent[0].InvoiceNumberInFactor;
        tempCurrent[0].InvoiceNumberInFactor = tempPrev[0].InvoiceNumberInFactor;
        tempPrev[0].InvoiceNumberInFactor = tempInvoiceNumberInFactor;
      }

      //swapp idtable
      let TempIdTable;
      TempIdTable = tempCurrent[0].idTable;
      tempCurrent[0].idTable = tempPrev[0].idTable;
      tempPrev[0].idTable = TempIdTable;

      tempArr.data.splice(idTablePrev - 1, 0, tempCurrent[0]);//add current row to prev
      tempArr.data.splice(idTablePrev, 0, tempPrev[0]);//add prev row to current

      setData(tempArr)
    }
    else {
      ErrorToast(constants.SwapRowErrorUp)
    }
  }

  const DownArrowFn = (item, e) => {
    e.preventDefault()
    let idTablePrev = item.idTable
    let nextItem = item.idTable + 1
    if (idTablePrev + 1 !== data?.data?.length) {
      let tempArr = { ...data }
      let tempCurrent = tempArr.data.splice(idTablePrev, 1)//delete current row
      let tempNext = tempArr.data.splice(idTablePrev, 1)//delete prev row        

      let tempRow;
      //swapp row content
      tempRow = tempCurrent[0].row;
      tempCurrent[0].row = tempNext[0].row;
      tempNext[0].row = tempRow;

      if (tempNext[0]?.OfficialFactorType !== 2) {
        let tempInvoiceNumberInFactorFa;
        tempInvoiceNumberInFactorFa = tempCurrent[0].InvoiceNumberInFactorFa;
        tempCurrent[0].InvoiceNumberInFactorFa = tempNext[0].InvoiceNumberInFactorFa;
        tempNext[0].InvoiceNumberInFactorFa = tempInvoiceNumberInFactorFa;
      }

      if (tempNext[0]?.OfficialFactorType !== 2) {
        //Swap InvoiceNumberInFactor
        let tempInvoiceNumberInFactor;
        tempInvoiceNumberInFactor = tempCurrent[0].InvoiceNumberInFactor;
        tempCurrent[0].InvoiceNumberInFactor = tempNext[0].InvoiceNumberInFactor;
        tempNext[0].InvoiceNumberInFactor = tempInvoiceNumberInFactor;
      }
      //swap Idtable
      let tempIdTable;

      tempIdTable = tempCurrent[0].idTable;
      tempCurrent[0].idTable = tempNext[0].idTable;
      tempNext[0].idTable = tempIdTable;

      tempArr.data.splice(idTablePrev, 0, tempCurrent[0]);//add current row to prev
      tempArr.data.splice(idTablePrev, 0, tempNext[0]);//add prev row to current
      setData(tempArr)
    }
    else {
      ErrorToast(constants.SwapRowErrorDonw)
    }
  }

  const option = (item, dataListFromTable, setDataListFromTable,) => {
    return <div className="d-flex justify-content-end">
      {item.StatusEn === 'Rejected' && <RejectedInvoice
        key={item.idTable}
        item={item}
        data={dataListFromTable}
        setData={setDataListFromTable}
        setShow={setShow}
        setContent={setContent}
        setTitle={setTitle}
        setSelectedForCheckAgain={setSelectedForCheckAgain}
        setviewDetail={setviewDetail}
        checkedList={checkedList}
        setCheckedList={setCheckedList}


      />}
      {item.StatusEn === 'Reserved' && !newReserved && <ReservedInvoice
        item={item}
        data={dataListFromTable}
        setData={setDataListFromTable}
        setShow={setShow}
        setContent={setContent}
        setTitle={setTitle}
        setviewDetail={setviewDetail}
      />}
      {(
        item.StatusEn === 'PendingToAccept' ||
        item.StatusEn === 'addNewRow' ||
        item.StatusEn === 'deleteRow' ||
        item.StatusEn === 'ReservedInPending' ||
        isReserved || isDeleted) && <PendingToAcceptInvoice
          item={item}
          data={dataListFromTable}
          setData={setDataListFromTable}
          idOfNewRow={idOfNewRow}
          setIdOfNewRow={setIdOfNewRow}
          lastFactorNumber={lastFactorNumber}
          setShow={setShow}
          setTitle={setTitle}
          setContent={setContent}
          setviewDetail={setviewDetail}
          setRowRejectedInPending={setRowRejectedInPending}
          setRowBckReservedInPending={setRowBckReservedInPending}
          setRowReservedInPending={setRowReservedInPending}
          setIsDeleted={setIsDeleted}
          setIsReserved={setIsReserved}
          setIsApprove={setIsApprove}
          reservedInPendInvoice={reservedInPendInvoice}
        />}
      {(item.StatusEn === 'Accepted' || item.StatusEn === 'ReturnRevoke' || isReservedAddedtoeAcceptInvoice) && <AcceptedInvoice
        item={item}
        setItemForDownload={setItemForDownload}
        columns={columns}
        setData={setData}
        data={data}
        setItemInLoading={setItemInLoading}
        itemInLoading={itemInLoading}

      />}
    </div>
  }
  const changeFactorNumber = (item) => {
    return (
      <div className='d-flex flex-row justify-content-center'>
        <span className="invoice-number">{item.InvoiceNumberInFactorFa}</span>
      </div>)
  }

  const movadianStatus = (item) => {


    if (parseInt(selectedStatus) === 1 || parseInt(selectedStatus) === 3) {
      return (<AcceptedInvoice
        item={item}
        setItemForDownload={setItemForDownload}
        columns={columns}
        setData={setData}
        data={data}
        setItemInLoading={setItemInLoading}
        itemInLoading={itemInLoading}
        setResendItemInLoading={setResendItemInLoading}
        resendItemInLoading={resendItemInLoading}
        type={'status'}
      />)
    }
    else if (parseInt(selectedStatus) === 4) {
      return (<ReservedInvoice
        item={item}
        data={data}
        setData={setData}
        setShow={setShow}
        setContent={setContent}
        setTitle={setTitle}
        setviewDetail={setviewDetail}
        setResendItemInLoading={setResendItemInLoading}
        resendItemInLoading={resendItemInLoading}
        type={'status'}
      />)

    }

  }



  return (

    <>
      <div className='table-context'>
        {loading && <div className='table-loading'>
          <div className="spinner-border" role="status" aria-hidden="true"></div>
        </div>}
        <table className="table table-bordered  invoice-table" >
          <thead>
            <tr>
              <th>ردیف</th>
              <th>مشترک</th>
              <th>ایمیل</th>
              <th>مبلغ</th>
              <th>درگاه</th>
              <th>{parseInt(selectedStatus) !== 4 ? 'تاریخ تراکنش' : 'تاریخ ایجاد'}</th>
              <th>وضعیت فاکتور</th>
              {(parseInt(selectedStatus) === 1 || parseInt(selectedStatus) === 3 || parseInt(selectedStatus) === 4) && <th>شماره مالیاتی</th>}
              {(parseInt(selectedStatus) === 1 || parseInt(selectedStatus) === 3 || parseInt(selectedStatus) === 4) && <th>سامانه مودیان</th>}
              {parseInt(selectedStatus) !== 2 && <th>شماره فاکتور</th>}
              <th>گزینه ها</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((item, idx) => {
              return (
                <tr key={idx}>
                  <td>{item?.row}</td>
                  <td>{item?.FirstNameAndLastName}</td>
                  <td >{parseInt(selectedStatus) !== 3 ? item?.Email : item?.EmailRevokOrReturned}</td>
                  <td>{item?.PayableAmountFa}</td>
                  <td>{item?.GatewayName}</td>
                  <td>{item?.OfficialFactorType !== 4 ? item?.PersianIssueDateFa : item?.OfficialFactorCreatePersianDateFa}</td>
                  <td className={
                    item.OfficialFactorType === 1 ? "accepted-invoice" :
                      item.OfficialFactorType === 2 ? "rejected-invoice" :
                        item.OfficialFactorType === 3 ? "returnedFromSale-invoice" :
                          item.OfficialFactorType === 4 ? "reserved-invoice" :
                            item.OfficialFactorType === null ? "pendingToAccept-invoice" : ''
                  }>
                    {item.Status}</td>

                  {/* {selectedStatus === 1 && <td>{changeFactorNumber(item)}</td>} */}

                  {(parseInt(selectedStatus) === 1 || parseInt(selectedStatus) === 3 || parseInt(selectedStatus) === 4) && <td> {item?.MoadianTaxId ? item?.MoadianTaxId : '---'}</td>}
                  {(parseInt(selectedStatus) === 1 || parseInt(selectedStatus) === 3 || parseInt(selectedStatus) === 4) && <td>
                    {movadianStatus(item)}

                  </td>}
                  {parseInt(selectedStatus) !== 2 &&
                    <td>
                      {parseInt(selectedStatus) === 4 && <span className='number-factor'>{item.InvoiceNumberInFactorFa}</span>}
                      {parseInt(selectedStatus) !== 4 && <div className='d-flex flex-row justify-content-center'>
                        <span className='number-factor'>{item.InvoiceNumberInFactorFa}</span>
                        {parseInt(selectedStatus) === 5 && item.OfficialFactorType !== 2 &&
                          <div className='d-flex flex-column justify-content-between'>
                            <span onClick={(e) => { UpArrowFn(item, e) }}><UpArrow /></span>
                            <span onClick={(e) => { DownArrowFn(item, e) }}><DownArrow /></span>
                          </div>
                        }
                      </div>}
                    </td>}
                  <td>{option(item, data, setData)}</td>
                </tr>
              )

            })}
          </tbody>
        </table>

      </div>

    </>
  )
}
export default InvoiceTable

